import type { ChangeEventHandler, FC, Ref } from 'react';
import React from 'react';

import { cnTumbler } from '../Tumbler.cn';

type TumblerControlProps = {
    checked: boolean;
    id: string;
    innerRef?: Ref<HTMLInputElement>;
    name?: string;
    onChange?: ChangeEventHandler<HTMLInputElement>;
    required?: boolean;
};

export const TumblerControl: FC<TumblerControlProps> = ({
    id,
    innerRef,
    checked,
    name,
    onChange,
    required,
}) => (
    <input
        id={id}
        hidden
        ref={innerRef}
        className={cnTumbler('Control')}
        name={name}
        checked={checked}
        value={String(checked)}
        type="checkbox"
        autoComplete="off"
        onChange={onChange}
        required={required}
    />
);
